import { render, staticRenderFns } from "./paomadeng.vue?vue&type=template&id=8d7dae5a&scoped=true&"
import script from "./paomadeng.vue?vue&type=script&lang=js&"
export * from "./paomadeng.vue?vue&type=script&lang=js&"
import style0 from "./paomadeng.vue?vue&type=style&index=0&id=8d7dae5a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8d7dae5a",
  null
  
)

export default component.exports